var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1952 6.65463C10.9616 5.70465 10.1042 5 9.08208 5C8.06002 5 7.20253 5.70465 6.96893 6.65463L5.65326 6.65463C5.21511 6.65463 4.85992 7.00982 4.85992 7.44797C4.85992 7.88612 5.21511 8.24131 5.65326 8.24131L7.18423 8.24131C7.55713 8.90423 8.26731 9.35203 9.08208 9.35203C9.89686 9.35203 10.607 8.90423 10.9799 8.24131L18.3467 8.24131C18.7848 8.24131 19.14 7.88612 19.14 7.44797C19.14 7.00982 18.7848 6.65463 18.3467 6.65463L11.1952 6.65463ZM18.3467 12.7747C18.7848 12.7747 19.14 12.4195 19.14 11.9813C19.14 11.5432 18.7848 11.188 18.3467 11.188H17.4889C17.1966 10.331 16.3847 9.71465 15.4288 9.71465C14.4729 9.71465 13.661 10.331 13.3687 11.188H5.65326C5.21511 11.188 4.85992 11.5432 4.85992 11.9813C4.85992 12.4195 5.21511 12.7747 5.65326 12.7747H13.4398C13.7787 13.5359 14.5418 14.0667 15.4288 14.0667C16.3158 14.0667 17.0789 13.5359 17.4177 12.7747H18.3467ZM19.14 16.5147C19.14 16.9528 18.7848 17.308 18.3467 17.308L9.34015 17.308C9.00129 18.0693 8.23823 18.6 7.35119 18.6C6.14941 18.6 5.17518 17.6258 5.17518 16.424C5.17518 15.2223 6.14941 14.248 7.35119 14.248C8.30709 14.248 9.11903 14.8644 9.41126 15.7214L18.3467 15.7214C18.7848 15.7214 19.14 16.0766 19.14 16.5147Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineFilter);
export default __webpack_public_path__ + "static/media/line-filter.98cd3935894373b991f557c392044169.svg";
export { ForwardRef as ReactComponent };